export default __webpack_public_path__ + "ae0dc4a2eff3357889436452bfe561c7.png";